import { render, staticRenderFns } from "./RolesMenu.vue?vue&type=template&id=0be69c7f"
import script from "./RolesMenu.vue?vue&type=script&lang=js"
export * from "./RolesMenu.vue?vue&type=script&lang=js"
import style0 from "./RolesMenu.vue?vue&type=style&index=0&id=0be69c7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports